<style src="./subscription.scss">
</style>

<script lang="ts">
  import Modal from "@components/modal";
  import Icon from "svelte-icon";
  import Badge from "@components/badge";

  import AppStore from "@assets/images/appstore.svg";
  import GooglePlay from "@assets/images/googleplay.svg";

  export let isOpen = false;
  export let onClose = () => null;
  export let price = null;
</script>

<Modal
  isOpen="{isOpen}"
  title="Você já ativou sua assinatura"
  onClose="{onClose}"
  showCloseButton="{false}">
  <div class="subscription-modal">
    {#if price}
      <div class="subscription-modal__product">
        <Badge
          title="{`${price?.product.name} - ${price?.name}`}"
          background="{price?.product.color}" />
      </div>
    {/if}

    <p>
      Baixe o app para explorar um novo jeito de aprender inglês online, melhor
      e mais rápido.
    </p>
    <div class="stores">
      <a
        href="https://apps.apple.com/br/app/cna-go/id1529651631"
        target="_blank">
        <Icon data="{AppStore}" stroke="transparent" fill="transparent" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=br.com.cnago.app"
        target="_blank">
        <Icon data="{GooglePlay}" stroke="transparent" fill="transparent" />
      </a>
    </div>
  </div>
</Modal>
